export const GET_INSTITUTE = 'GET_INSTITUTE';
export const LOADING_INSTITUTE = 'LOADING_INSTITUTE';
export const SAVE_LOADER_INSTITUTE = 'SAVE_LOADER_INSTITUTE';
export const FORM_FAIL = "FORM_FAIL";
export const INSTITUTE_FAIL = 'INSTITUTE_FAIL';